// extracted by mini-css-extract-plugin
module.exports = {"tag_head_container":"style_tag_head_container___hy4k","section":"style_section__xAsYQ"};